import type { TablePaginationConfig } from 'antd'

export interface PaginatedItems<T> {
  items: T[]
  pagination: { totalRecords: number }
}

export function ensureArray<T>(value: unknown): T[] {
  return Array.isArray(value) ? value : []
}

const PAGE_SIZE_KEY = 'admin_table_page_size'
const DEFAULT_PAGE_SIZE = 10

export function getPersistedPageSize(): number {
  try {
    const stored = localStorage.getItem(PAGE_SIZE_KEY)
    if (stored) {
      const parsed = Number(stored)
      if (Number.isInteger(parsed) && parsed > 0) return parsed
    }
  } catch {
    // localStorage unavailable
  }
  return DEFAULT_PAGE_SIZE
}

function savePageSize(size: number): void {
  try {
    localStorage.setItem(PAGE_SIZE_KEY, String(size))
  } catch {
    // ignore
  }
}

export function tablePaginationConfig(tableProps: {
  pagination?: TablePaginationConfig | false
}): TablePaginationConfig {
  return {
    ...(typeof tableProps.pagination === 'object' ? tableProps.pagination : {}),
    showTotal: (total: number) => `${total} items`,
    showSizeChanger: true,
    onShowSizeChange: (_current, size) => savePageSize(size),
  }
}
